import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import {
    Link,
    useLocation
    // useNavigate
} from 'react-router-dom';
// import ReactSelect from 'react-select';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import _ from 'lodash';
// import DataTable from 'react-data-table-component';
// import moment from 'moment';
import { useAuth } from '../../hooks/useAuth';
// import RewardsPDF from '../Vendors/VendorDetail/RewardsPDF';
import { PDFDownloadLink } from '@react-pdf/renderer';
import AgencyRewardsPdf from './AgencyRewardsPdf';
// const customStyles = {
//     rows: {
//         style: {
//             // minHeight: '72px' // override the row height
//             textAling: 'center'
//         }
//     },
//     headCells: {
//         style: {
//             paddingLeft: '8px', // override the cell padding for head cells
//             paddingRight: '8px',
//             backgroundColor: '#13aa61',
//             color: 'white',
//             '&:hover': {
//                 cursor: 'pointer'
//             }
//         }
//     }
// };
// const options = {};

const AgencyDetails = () => {
    const { getToken } = useAuth();
    const [data, setData] = useState();
    // const [transitRewards, setTransitRewards] = useState();
    // const navigate = useNavigate();
    // const [totalRecords, setTotalRecords] = useState(0);
    // const [pageSize, setPageSize] = useState(10);
    const [allRewards, setAllRewards] = useState(false);

    const { state } = useLocation();

    useEffect(() => {
        if (state?.agency_id) {
            getAgencyDetails(state?.agency_id);
        }
    }, []);

    const getAgencyDetails = async (id = '') => {
        const token = getToken();
        if (id && token) {
            new WebApiCalls()
                .getSingleAgency(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        setData(res?.data);
                        // getAgencyRewards(pageSize, 1, id);
                    }
                })
                .catch((err) => {
                    console.log('Error in Agency details:   ', err);
                });
        }
    };
    // const getAgencyRewards = async (pageSize = 10, pageNo = 0, id = '') => {
    //     const token = getToken();
    //     if (id && token) {
    //         new WebApiCalls()
    //             .getAllRewards(token, pageSize, pageNo, '', '', id)
    //             .then((res) => {
    //                 if (res?.code == 200) {
    //                     setTransitRewards(res?.data?.rewards);
    //                     setTotalRecords(res?.data?.totalCount);
    //                 }
    //             })
    //             .catch((err) => {
    //                 console.log('Error in Agency details:   ', err);
    //             });
    //     }
    // };
    const getAllAgencyRewards = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllRewards(token, '', '', '', '', state?.agency_id, '', true)
                .then((res) => {
                    if (res?.code === 200) {
                        setAllRewards(res);

                        console.log('Res here:  ', res);
                    }
                })
                .catch((err) => {
                    console.log('Error in Rewards details:   ', err);
                });
        }
    };

    useEffect(() => {
        getAllAgencyRewards();
    }, []);
    // const updateSingle = () => {};

    // const columns = [
    //     {
    //         name: (
    //             <h6 className="text-capitalize mt-2 text-center">
    //                 <span className="fw-bold">Name</span>
    //             </h6>
    //         ),
    //         selector: (row) => row.name,
    //         center: true
    //         // sortable: true
    //     },
    //     {
    //         name: (
    //             <h6 className="text-capitalize mt-2 text-center">
    //                 <span className="fw-bold ">Allowed Redeems</span>
    //             </h6>
    //         ),
    //         selector: (row) => row.noOfAllowRedeems,
    //         sortable: true,
    //         center: true
    //     },
    //     {
    //         name: (
    //             <h6 className="text-capitalize mt-2 text-center">
    //                 <span className="fw-bold">Redeemed Count</span>
    //             </h6>
    //         ),
    //         selector: (row) => row?.redeemedCount,
    //         // sortable: true,
    //         center: true
    //     },
    //     {
    //         name: (
    //             <h6 className="text-capitalize mt-2 text-center">
    //                 <span className="fw-bold">Required Points</span>
    //             </h6>
    //         ),
    //         selector: (row) => row?.requiredPoints,
    //         sortable: true,
    //         center: true
    //     },
    //     {
    //         name: (
    //             <h6 className="text-capitalize mt-2 text-center">
    //                 <span className="fw-bold">Status</span>
    //             </h6>
    //         ),
    //         selector: (row) => (
    //             <select
    //                 value={row?.status}
    //                 disabled
    //                 className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
    //                 aria-label="Default select example"
    //             >
    //                 <option value={'active'}>Active</option>
    //                 <option value={'inactive'}>Inactive</option>
    //             </select>
    //         ),
    //         center: true
    //         // sortable: true
    //     },
    //     // {
    //     //     name: (
    //     //         <h6 className="text-capitalize mt-2 text-center">
    //     //             <span className="fw-bold">Description</span>
    //     //         </h6>
    //     //     ),
    //     //     selector: (row) => row?.description,
    //     //     center: true
    //     //     // sortable: true
    //     // },
    //     {
    //         name: (
    //             <h6 className="text-capitalize mt-2 text-center">
    //                 <span>Validity</span>
    //             </h6>
    //         ),
    //         selector: (row) => (row?.validity ? moment(row?.validity).format('YYYY-MM-DD') : ''),
    //         center: true
    //         // sortable: true
    //     }
    //     // {
    //     //     name: (
    //     //         <h6 className="text-capitalize mt-2 text-center">
    //     //             <span className="fw-bold">Action</span>
    //     //         </h6>
    //     //     ),
    //     //     selector: (row) => (
    //     //         <div className="d-flex">
    //     //             <div className="view-detail">
    //     //                 <img
    //     //                     width={15}
    //     //                     className="me-3"
    //     //                     src={viewIcon}
    //     //                     alt=""
    //     //                     onClick={() => {
    //     //                         navigate("/rewards/reward-detail", { state: { reward_id: row?._id, reward_detail: row } })
    //     //                     }}
    //     //                 />
    //     //             </div>
    //     //             <div className="edit-detail">
    //     //                 <img
    //     //                     width={15}
    //     //                     className="me-3"
    //     //                     src={editIcon}
    //     //                     alt=""
    //     //                     onClick={() => {
    //     //                         // setSelectedItem(row);
    //     //                         // setShowEditModal(true);
    //     //                     }}
    //     //                 />
    //     //             </div>
    //     //             <div className="del-detail">
    //     //                 <img
    //     //                     width={15}
    //     //                     src={delIcon}
    //     //                     alt=""
    //     //                     onClick={() => {
    //     //                     }}
    //     //                 />
    //     //             </div>
    //     //         </div>
    //     //     ),
    //     //     center: true
    //     //     // sortable: true
    //     // }
    // ];
    // const handlePerRowsChange = async (pageSize, pageNo) => {
    //     getAgencyRewards(pageSize, pageNo, state?.agency_id);
    //     setPageSize(pageSize);
    //     // setLoading(false);
    // };
    // const handlePageChange = (pageNo) => {
    //     getAgencyRewards(pageSize, pageNo, state?.agency_id);
    // };

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={6} md={6} className="text-center ">
                    <div className="d-flex justify-content-end gap-2">
                        {allRewards?.code === 200 ? (
                            <PDFDownloadLink document={<AgencyRewardsPdf agencyData={data} rewards={allRewards?.data?.rewards} />} fileName="rewards.pdf">
                                <Button className="export-file justify-content-center w-140 align-items-center" style={{ background: '#198754' }}>
                                    Export Rewards
                                </Button>
                            </PDFDownloadLink>
                        ) : (
                            ''
                        )}
                        <Link to="/agencies">
                            <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                        </Link>
                    </div>
                </Col>
            </Row>
            {/* <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">Agency Details</div>
                </Col>
            </Row> */}
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ">
                    <Row>
                        <Col sm={6} md={3} className="mb-1">
                            <div className="detail-image-container">
                                <img src={data?.logo} alt="logo-image" />
                            </div>
                        </Col>
                        <Col sm={6} md={9} className="mb-1">
                            <Row>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Email</div>
                                    <div className="detail-value">{data?.email}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Name</div>
                                    <div className="detail-value">{data?.name}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Phone Number</div>
                                    <div className="detail-value">{data?.phone_no}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Transit Type</div>
                                    <div className="detail-value">{_.capitalize(data?.transit_mediums?.join(', '))}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Total Commuters</div>
                                    <div className="detail-value">{data?.noOfCommuters}</div>
                                </Col>
                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Number of Routes</div>
                                    <div className="detail-value">{data?.noOfRoutes}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {/* <hr className="mt-3" />
                    <Row className="mt-4">
                        <Col md={4}>
                            <div className="detail-value mb-4">Rewards Listing</div>
                        </Col>
                    </Row>

                    <Row>
                        <DataTable
                            columns={columns}
                            data={transitRewards}
                            // selectableRows
                            responsive
                            pagination
                            paginationServer
                            paginationTotalRows={totalRecords}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            // direction="auto"
                            // fixedHeaderScrollHeight="300px"
                            // subHeaderAlign="right"
                            // subHeaderWrap
                            customStyles={customStyles}
                            // onSelectedRowsChange={handleRowSelected}
                            // clearSelectedRows={toggleCleared}
                            // defaultSortFieldId={1}
                        />
                    </Row> */}
                </Col>
            </Row>
        </>
    );
};

export default AgencyDetails;
